import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { GenerateAccessKeysInput, GenerateAccessKeysPayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = GenerateAccessKeysInput;
type TData = GenerateAccessKeysPayload;

export const useUserGenerateAccessKeys = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation userGenerateAccessKeys($input: GenerateAccessKeysInput!) {
      userGenerateAccessKeys(input: $input) {
        success
        errors
        errorCode
        accessKey
        accessSecret
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
